export default {
  survey_filter: (state) => state.survey_filter,
};
